import React from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColLabelValue } from '../../../../../components/pdf/TableHelpers'
import Text from '../../../../../components/pdf/Text'
import Bar from '../../../../../components/pdf/Bar'
import View from '../../../../../components/pdf/View'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import Separator from '../../../../../components/pdf/Separator'
import { getAddressValue, getPlaceFieldValue } from '../../_helpers/pdfHelpers'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { formatCnpj } from '@btime/helpers'

const ClientData = () => {
  const serviceOrder = useServiceOrder()

  const name =
    serviceOrder.place.placeLevelsResume.length > 2
      ? serviceOrder.place.placeLevelsResume[2].name
      : serviceOrder.place.resume
  const placeName = serviceOrder.place.name

  const cnpj = formatCnpj(getPlaceFieldValue(serviceOrder.place, 'CPF/CNPJ').toString())

  return (
    <View>
      <Separator weight={4} />
      <Grid justify="space-between" align="center">
        <Col>
          <Text bold size="h4" align="left">
            Dados do Cliente
          </Text>
        </Col>
      </Grid>
      <Separator weight={2} />
      <Table width="100%" useFontBaseColor>
        <TableRow useFontBaseColor>
          <TableColLabelValue colSpan={2} label={'Cliente'} value={name} useFontBaseColor semibold />
        </TableRow>
        <TableRow useFontBaseColor>
          <TableColLabelValue colSpan={2} label={'Site'} value={`${placeName}`} useFontBaseColor semibold />
        </TableRow>
        <TableRow useFontBaseColor>
          <TableColLabelValue colSpan={2} label={'CNPJ/CPF'} value={cnpj} useFontBaseColor semibold />
        </TableRow>

        <TableRow useFontBaseColor>
          <TableColLabelValue
            colSpan={2}
            label={'Endereço completo'}
            value={getAddressValue(serviceOrder)}
            useFontBaseColor
            semibold
          />
        </TableRow>
      </Table>
      <Separator weight={4} />
      <Bar />
    </View>
  )
}

export default ClientData
